// Imported first by main.tsx, so a support tab's storage is the tab's own
// before any other module reads it (lib/support-session.ts).
import { scopeStorageToSupportTab } from "@/lib/support-session";

scopeStorageToSupportTab();
